module.exports = __webpack_public_path__ + "static/media/majordata.3af28ac9.csv";